import GroupsEnum from '../data/groups/GroupsEnum';

/**
 * All theses methods could be done with find method, but I prefer to break the loop when it's possible
 * In these cases, the gain is very low but still worth
 * BTW : Method could be factorised but I prefer to have distinct method if any specific data is added in the future
 */

export function userIsSuperAdmin(userProfile) {
  let res = false;
  if (userProfile.permissions.length > 0) {
    for (let i = 0; i < userProfile.permissions.length; i++) {
      if (userProfile.permissions[i].groupReference === GroupsEnum.SUPER_ADMIN) {
        res = true;
        break;
      }
    }
  }
  return res;
}

export function isInChargeOf(myProfileReference, userProfile) {
  let res = false;
  for (let i = 0; i < userProfile.inCharge.length; i++) {
    if (userProfile.inCharge[i].userReference === myProfileReference) {
      res = true;
      break;
    }
  }
  return res;
}

export function isAdministrator(myProfile) {
  let res = false;
  for (let i = 0; i < myProfile.permissions.length; i++) {
    if (myProfile.permissions[i].groupReference === GroupsEnum.ADMIN) {
      res = true;
      break;
    }
  }
  return res;
}

export function isAccounting(myProfile) {
  let res = false;
  for (let i = 0; i < myProfile.permissions.length; i++) {
    if (myProfile.permissions[i].groupReference === GroupsEnum.COMPTA) {
      res = true;
      break;
    }
  }
  return res;
}

export function canSeeIt(permissions, userPermissions) {
  if (!permissions || permissions.length === 0) {
    return true;
  }
  let res = false;
  for (let i = 0; i < userPermissions.length; i++) {
    const perm = userPermissions[i];
    if (permissions.indexOf(perm.groupReference) > -1) {
      res = true;
      break;
    }
  }
  return res;
}

export function checkIfCanEditUser(myProfile, userProfile) {
  if (!myProfile || !userProfile) {
    return false;
  }
  if (myProfile.reference === userProfile.reference) {
    return false;
  }
  if (userIsSuperAdmin(myProfile)) {
    return true;
  }
  if (isAdministrator(myProfile)) {
    return true;
  }
  if (isInChargeOf(myProfile.reference, userProfile)) {
    return true;
  }
  return false;
}
